import { produce } from 'immer'
import type { State } from '../../typings'

export const setActivitySummaryStatsLoadingProducer = produce<State, [boolean]>(
  (draft, payload) => {
    draft.statsState.loading = payload
  },
)
